import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";

// apollo
import { GET_JOB_DAY_CREW_ASSIGNMENTS } from "../../../graphql/jobDay/jobDay.queries";
import { DELETE_JOB_DAY } from "../../../graphql/jobDay/jobDay.mutations";

// components
import DeleteObjectWithModal from "../../../blockGroups/deletion/DeleteObjectWithModal/DeleteObjectWithModal.blockgroup";

// collections
import JobDayDetailHeader from "./collections/JobDayDetailHeader.collection";
import JobDayJobInfo from "./collections/JobDayJobInfo.collection";
import JobDayTimeTicketStats from "./collections/JobDayTimeTicketStats/JobDayTimeTicketStats.collection";
import JobDayDetailAssignments from "./collections/JobDayDetailAssignments/JobDayDetailAssignments.collection";

// forms
import EditJobDayFormController from "./forms/editJobDay/EditJobDay.form.controller";
import WithGqlQuery from "../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper";

// mui
import { Container, Grid } from "@mui/material";
import FinishTimeTicketsFormController from "./forms/FinishTimeTickets/FinishTimeTickets.form.controller";
import UpdateTimeTicketStageFormController from "./forms/updateTimeTicketStage/UpdateTimeTicketStage.form.controller";
import MarkAsPaidFormController from "./forms/MarkAsPaid/MarkAsPaid.form.controller";

// utils
import { createUserGroupList } from "../../../shared/privileges/userGroups";

export default function JobDayDetail({ usersGroups }) {
  const groups = createUserGroupList(usersGroups);
  const history = useHistory();
  const { jobDayId: jobDayIdString } = useParams();
  const jobDayId = Number(jobDayIdString);

  const [approvalStage, setApprovalStage] = useState("preliminary");
  // modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showFinishModal, setShowFinishModal] = useState(false);
  const [showMarkModal, setShowMarkModal] = useState(false);

  return (
    <div id="JobDayDetail">
      <EditJobDayFormController
        id={jobDayId}
        visible={showEditModal}
        closeForm={() => setShowEditModal(false)}
      />
      <FinishTimeTicketsFormController
        id={jobDayId}
        visible={showFinishModal}
        closeForm={() => setShowFinishModal(false)}
      />

      <UpdateTimeTicketStageFormController
        id={jobDayId}
        approvalStage={approvalStage}
        visible={showApproveModal}
        closeForm={() => setShowApproveModal(false)}
      />

      <MarkAsPaidFormController
        id={jobDayId}
        visible={showMarkModal}
        closeForm={() => setShowMarkModal(false)}
      />

      <JobDayDetailHeader
        id={jobDayId}
        onFinishClick={() => setShowFinishModal(true)}
        onApproveClick={(approvalStage) => {
          setApprovalStage(approvalStage);
          setShowApproveModal(true);
        }}
        onMarkPaidClick={() => setShowMarkModal(true)}
        onEditClick={() => setShowEditModal(true)}
        onGenerateClick={() =>
          history.push(`/schedule/jobDay/${jobDayId}/generate-time-ticket-pdf`)
        }
        usersGroups={usersGroups}
      />

      <Container maxWidth disableGutters>
        <Grid container spacing={2} justifyContent="space-between" maxWidth={"lg"}>
          <Grid item xs={6}>
            <JobDayJobInfo id={jobDayId} />
          </Grid>
          <Grid item xs={6}>
            <JobDayTimeTicketStats id={jobDayId} />
          </Grid>
        </Grid>
      </Container>

      <WithGqlQuery
        component={JobDayDetailAssignments}
        query={GET_JOB_DAY_CREW_ASSIGNMENTS}
        variables={{ id: jobDayId }}
      />

      {groups.includes("Admin") && (
        <DeleteObjectWithModal
          id={jobDayId}
          mutation={DELETE_JOB_DAY}
          deleteLabel={"Delete Job Day"}
          deleteTitle={"Delete Job Day"}
          deleteMessage={
            "Are you sure you want to delete this Job Day? This will delete all Crew Member Assignments associated with this Job Day."
          }
          successObjectKey="deleteJobDay"
          entityName="JobDay"
        />
      )}
    </div>
  );
}
